define('lib/view/StatusAnnouncer',[],function () {

    /**
     * Shared screen-reader status live region (WCAG 4.1.3). adacompliant defines it
     * directly in main_layout.tpl; other themes (default included) don't, so it's
     * created on demand here rather than editing their templates.
     */
    return {

        get: function () {
            var announcer = document.getElementById('sb_status_announcer');
            if (!announcer) {
                announcer = document.createElement('div');
                announcer.id = 'sb_status_announcer';
                announcer.setAttribute('role', 'status');
                announcer.setAttribute('aria-live', 'polite');
                announcer.setAttribute('aria-atomic', 'true');
                // visually hidden (sr-only) — themes other than adacompliant have no CSS for it
                announcer.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;' +
                    'overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
                document.body.appendChild(announcer);
            }

            return announcer;
        },

        announce: function (text) {
            this.get().textContent = text;
        }

    };

});

